export const countCityCars = ({ countCityCars }) => countCityCars;
export const countOtherCars = ({ countOtherCars }) => countOtherCars;
export const lastPage = ({ lastPage }) => lastPage;
export const filterCars = ({ filterCars }) => filterCars;
export const filterParams = ({ filterParams }) => filterParams;
export const waitForRequestFilterParams = ({ waitForRequestFilterParams }) => waitForRequestFilterParams;
export const selectedData = ({ selectedData }) => selectedData;
